import { render, staticRenderFns } from "./image-upload-custom.vue?vue&type=template&id=0a10af26&scoped=true&"
import script from "./image-upload-custom.vue?vue&type=script&lang=js&"
export * from "./image-upload-custom.vue?vue&type=script&lang=js&"
import style0 from "./image-upload-custom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./image-upload-custom.vue?vue&type=style&index=1&id=0a10af26&lang=scss&scoped=true&"
import style2 from "./image-upload-custom.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10af26",
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
